<template>
  <div class="search-wrapper flex flex-row">
    <search-icn
      width="20px"
      height="20px"
      class="search-icon"
      :class="isInput || keyword ? 'white-icon' : `${color}-icon`"
    ></search-icn>
    <input
      type="text"
      v-model="keyword"
      placeholder="キーワードで検索"
      :class="[
        'border-4 border-b-0 h-10 search-input',
        `border-${color}`,
        `${color}`,
        isInput || keyword.length ? `bg-${color} text-white font-bold` : '',
      ]"
    />
    <clear-icn
      class="clear-icon"
      :class="`${color}-icon`"
      v-if="keyword"
      @click="clearInput"
      width="20px"
      height="20px"
    ></clear-icn>
  </div>
</template>

<script>
import { useKeywordSearch } from '@/services/useKeywordSearch'
import { useInputSelectSearch } from '@/services/useInputSelectSearch'

import SearchIcn from '@/assets/icons/search.svg?inline'
import ClearIcn from '@/assets/icons/clear.svg?inline'

export default {
  name: 'AppSearchInput',

  components: {
    SearchIcn,
    ClearIcn,
  },

  props: {
    color: {
      type: String,
      default: '',
    },
  },

  setup() {
    const { isFocus, keyword, clearInput } = useKeywordSearch()
    const { isInput } = useInputSelectSearch()

    return { isFocus, keyword, clearInput,isInput }
  },
}
</script>

<style lang="scss" scoped>
.search-wrapper {
  position: relative;

  .search-input {
    box-sizing: border-box;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    padding-left: 42px !important;
    font-size: 18px;
    width: 488px;
  }

  svg.search-icon {
    position: absolute;
    text-align: center;
    margin: 10px;
  }

  svg.clear-icon {
    position: absolute;
    right: 0px;
    margin: 10px;
  }
}
</style>
